module.exports = __webpack_public_path__ + "5c63a6f5619fbf9db04fcd679f2a014c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-robin-hood.png
// module id = 2285
// module chunks = 0